import { SchedulerDefinition } from "../../api/scheduler-service";

export class SampleEventCalculationRequestPayload {
    constructor(
        public schedulerDefinition : SchedulerDefinition,
        public sampleSize: number
    ) {

    }
}
